import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolHerald = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.61688 6.73806C6.00038 6.73806 6.31126 6.15106 6.31126 5.42696C6.31126 4.70286 6.00038 4.11586 5.61688 4.11586C5.23339 4.11586 4.9225 4.70286 4.9225 5.42696C4.9225 6.15106 5.23339 6.73806 5.61688 6.73806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.6746 0V2.56053C7.6746 2.56053 7.7454 2.60621 7.85276 2.69758C7.24289 2.19735 6.464 1.89813 5.6143 1.89813C4.84911 1.89813 4.14331 2.14481 3.56542 2.55824V0C2.50101 0.349474 1.79521 1.46185 1.37264 2.40292C1.0323 3.15669 0.865559 3.9767 0.865559 4.80584V5.50479C1.41147 5.52535 2.0693 6.0804 2.16295 6.16263C2.50101 7.76153 3.91718 8.9607 5.61658 8.9607C7.31599 8.9607 8.73216 7.76153 9.07021 6.16263C9.07021 6.16719 9.07021 6.16948 9.06793 6.17405C9.06793 6.17405 9.78971 5.52763 10.3767 5.50479V4.80584C10.3767 3.97898 10.2077 3.15897 9.86966 2.40292C9.44481 1.46185 8.73901 0.349474 7.6746 0ZM5.61658 7.30013C4.58186 7.30013 3.74358 6.46185 3.74358 5.42713C3.74358 4.39241 4.58186 3.55413 5.61658 3.55413C6.6513 3.55413 7.48958 4.39241 7.48958 5.42713C7.4873 6.46185 6.64901 7.30013 5.61658 7.30013Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.55094 6.73824C1.55094 6.73824 1.85473 8.32572 2.30927 8.86021C2.37095 8.9333 2.40749 9.02466 2.40749 9.12288V9.99999C2.40749 9.99999 0.481958 9.0635 3.8147e-06 8.07446L1.55094 6.73824Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.76471 6.73824C9.76471 6.73824 9.46092 8.32572 9.00637 8.86021C8.9447 8.93558 8.90815 9.02695 8.90815 9.12288V9.99999C8.90815 9.99999 10.8337 9.0635 11.3156 8.07446L9.76471 6.73824Z",
			fill: "currentColor"
		})
	]
});
export default SvgLolHerald;
